export default __webpack_public_path__ + "static/media/txt.c436d662.svg";